// src/components/strumenti/ConversioniIdrauliche.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const MCA_PER_BAR = 10.1972;

export default function ConversioniIdrauliche() {
  const [tab, setTab] = useState("portata");

  // Portata
  const [modoPortata, setModoPortata] = useState("lmin_m3h");
  const [valPortata, setValPortata] = useState("");
  const vP = leggiNumero(valPortata)||0;
  const risPortata = modoPortata==="lmin_m3h" ? (vP*60)/1000 : (vP*1000)/60;

  // Pressione
  const [modoPress, setModoPress] = useState("bar_mca");
  const [valPress, setValPress] = useState("");
  const vPr = leggiNumero(valPress)||0;
  const risPress = modoPress==="bar_mca" ? vPr*MCA_PER_BAR : vPr/MCA_PER_BAR;

  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16 }}>
        <button onClick={()=>setTab("portata")} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${tab==="portata"?"#2563eb":"#e5e7eb"}`, background: tab==="portata"?"#eff6ff":"#fff", color: tab==="portata"?"#2563eb":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Portata</button>
        <button onClick={()=>setTab("pressione")} style={{ flex:1, padding:"8px", borderRadius:8, border:`1px solid ${tab==="pressione"?"#2563eb":"#e5e7eb"}`, background: tab==="pressione"?"#eff6ff":"#fff", color: tab==="pressione"?"#2563eb":"#6b7280", fontSize:12, fontWeight:700, cursor:"pointer" }}>Pressione</button>
      </div>

      {tab==="portata" ? (
        <>
          <div style={{ display:"flex", gap:6, marginBottom:12 }}>
            <button onClick={()=>{setModoPortata("lmin_m3h");setValPortata("");}} style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${modoPortata==="lmin_m3h"?"#2563eb":"#e5e7eb"}`, background: modoPortata==="lmin_m3h"?"#eff6ff":"#fff", color: modoPortata==="lmin_m3h"?"#2563eb":"#6b7280", fontSize:11, fontWeight:700, cursor:"pointer" }}>l/min → m³/h</button>
            <button onClick={()=>{setModoPortata("m3h_lmin");setValPortata("");}} style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${modoPortata==="m3h_lmin"?"#2563eb":"#e5e7eb"}`, background: modoPortata==="m3h_lmin"?"#eff6ff":"#fff", color: modoPortata==="m3h_lmin"?"#2563eb":"#6b7280", fontSize:11, fontWeight:700, cursor:"pointer" }}>m³/h → l/min</button>
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={lbl}>{modoPortata==="lmin_m3h" ? "Portata (l/min)" : "Portata (m³/h)"}</label>
            <input value={valPortata} onChange={e=>setValPortata(e.target.value)} style={inp} placeholder="Es. 20"/>
          </div>
          <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risultato</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#2563eb" }}>
              {vP>0 ? risPortata.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
              <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modoPortata==="lmin_m3h" ? "m³/h" : "l/min"}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <div style={{ display:"flex", gap:6, marginBottom:12 }}>
            <button onClick={()=>{setModoPress("bar_mca");setValPress("");}} style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${modoPress==="bar_mca"?"#2563eb":"#e5e7eb"}`, background: modoPress==="bar_mca"?"#eff6ff":"#fff", color: modoPress==="bar_mca"?"#2563eb":"#6b7280", fontSize:11, fontWeight:700, cursor:"pointer" }}>bar → m.c.a.</button>
            <button onClick={()=>{setModoPress("mca_bar");setValPress("");}} style={{ flex:1, padding:"7px", borderRadius:8, border:`1px solid ${modoPress==="mca_bar"?"#2563eb":"#e5e7eb"}`, background: modoPress==="mca_bar"?"#eff6ff":"#fff", color: modoPress==="mca_bar"?"#2563eb":"#6b7280", fontSize:11, fontWeight:700, cursor:"pointer" }}>m.c.a. → bar</button>
          </div>
          <div style={{ marginBottom:16 }}>
            <label style={lbl}>{modoPress==="bar_mca" ? "Pressione (bar)" : "Prevalenza (m.c.a.)"}</label>
            <input value={valPress} onChange={e=>setValPress(e.target.value)} style={inp} placeholder="Es. 3"/>
          </div>
          <div style={{ background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Risultato</div>
            <div style={{ fontSize:22, fontWeight:800, color:"#2563eb" }}>
              {vPr>0 ? risPress.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
              <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>{modoPress==="bar_mca" ? "m.c.a." : "bar"}</span>
            </div>
          </div>
        </>
      )}

      <button onClick={()=>{setValPortata("");setValPress("");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
